import { default as FusePageCarded } from '@fuse/core/FusePageCarded/FusePageCarded';
import { useThemeMediaQuery } from '@fuse/hooks';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CreateDocumentScreen from './CreateDocumentScreen';

function CreateDocumentPage() {
  const { t } = useTranslation('translations');
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <FusePageCarded
      header={<div className="p-5" />}
      content={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
          }}
        >
          <Box
            sx={{
              width: 'fit-content',
              minWidth: { xs: '92vw', sm: 520 },
              maxWidth: 900,
              minHeight: 700,
              position: 'relative',
              p: 3,
            }}
          >
            <CreateDocumentScreen />
          </Box>
        </Box>
      }
      scroll="content"
    />
  );
}

export default CreateDocumentPage;
